
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trafficbox",
      function () {
        return require("private-next-pages/trafficbox/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trafficbox"])
      });
    }
  